// eslint-disable-next-line max-len
import { AttendanceVociListElement } from "@/components/attendanceVociListElement/attendanceVociListElement";
// eslint-disable-next-line max-len
import { useAttendanceMobileEmployeeVociTab } from "./attendanceMobileEmployeeVociTab/useAttendanceMobileEmployeeVociTab";
import ConfirmationDialog from "@/components/confirmationDialog/ConfirmationDialog";
import { showTranslated, translate } from "@/config/translator";
import { PressableDashedBox } from "@/components/pressableDashedBox/pressableDashedBox";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
// eslint-disable-next-line max-len
import { AttendanceMobileAddVoceBottomSheet } from "./attendanceMobileEmployeeVociTab/attendanceMobileAddVoceBottomSheet";

type AttendanceMobileEmployeeVociTabProps = {
  employeeMatricola: number;
  employeeFiliale: number;
};

export function AttendanceMobileEmployeeVociTab({
  employeeMatricola,
  employeeFiliale,
}: AttendanceMobileEmployeeVociTabProps) {
  const {
    onRemoveVoce,
    onOpenRemoveVoceDialog,
    aboutToRemoveVoce,
    removeVoceConfirmationOpen,
    onCloseRemoveVoceDialog,
    attendance,
    lang,
    addVoceBottomSheetOpen,
    setAddVoceBottomSheetOpen,
  } = useAttendanceMobileEmployeeVociTab({
    employeeMatricola,
    employeeFiliale,
  });

  return (
    <div className="flex flex-col gap-8">
      <PressableDashedBox
        onClick={() => setAddVoceBottomSheetOpen(true)}
        icon={faPlus}
      >
        {translate("addVoce", lang)}
      </PressableDashedBox>
      <div className="flex flex-col gap-3">
        <h2 className="text-xl font-medium">
          {translate("enteredVoci", lang)}
        </h2>
        {attendance?.voci.map((voce, index) => (
          <AttendanceVociListElement
            onRemove={() => onOpenRemoveVoceDialog(index)}
            voce={voce}
          />
        ))}
      </div>
      <ConfirmationDialog
        isOpen={removeVoceConfirmationOpen}
        onCancel={onCloseRemoveVoceDialog}
        onConfirm={onRemoveVoce}
        titleString={translate("areYouSure", lang)}
        messageString={
          attendance && aboutToRemoveVoce
            ? translate("youAreAboutToRemoveVoce", lang, {
                "{voceName}": showTranslated(aboutToRemoveVoce.name, lang),
                "{employeeName}": attendance.employee.name,
              })
            : ""
        }
      />
      <AttendanceMobileAddVoceBottomSheet
        isOpen={addVoceBottomSheetOpen}
        onClose={() => setAddVoceBottomSheetOpen(false)}
        employeeMatricola={employeeMatricola}
        employeeFiliale={employeeFiliale}
      />
    </div>
  );
}
